import { useQuery } from '@hooks/reactQuery';

import { getMiddlewareVendors } from '@api/middlewareSMO';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { MIDDLEWARE_SMO_VENDORS } from '@constants/queryKeys';

interface IUseQueryMiddlewareSmoVendorsReturned {
	vendorOptions: TSelectOption[];
	isLoadingVendorOptions: boolean;
}

const useQueryMiddlewareSmoVendors = (): IUseQueryMiddlewareSmoVendorsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [MIDDLEWARE_SMO_VENDORS],
		queryFn: extractQueryParams(getMiddlewareVendors),
		select: nameTitleToOptionFormatted,
		allowedRoles: [EUserRoles.smoLightUpdater],
		...refetchOptions,
	});

	return {
		vendorOptions: data || [],
		isLoadingVendorOptions: isInitialLoading,
	};
};

export default useQueryMiddlewareSmoVendors;
